/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Id_Required_ErrorInputs */



/**
* | output |
* | --- |
* | "Event group ID is required" |
*
* @param {Iframe_Remote_Event_Group_Id_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_id_required_error = /** @type {((inputs?: Iframe_Remote_Event_Group_Id_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Id_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID du groupe d'evenements requis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisgruppen-ID ist erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È richiesto l'ID del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требуется идентификатор группы событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere el ID del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组 ID 为必填项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループIDが必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप आईडी आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("É necessário o ID do grupo de eventos.")
	return /** @type {LocalizedString} */ ("Event group ID is required")
});